import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import onClickOutside from 'react-onclickoutside';
import InputText from '../Inputs/InputText';

class InputDropdown extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    headerText: PropTypes.string,
    subtext: PropTypes.string,
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    inputPattern: PropTypes.string.isRequired,
    valid: PropTypes.bool,
  };
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }
  handleClick(e) {
    const { open } = this.state;
    if (e.target) {
      this.setState({ open: !open });
    }
  }
  handleClickOutside = () => this.setState({ open: false });
  render() {
    const { value, onChange, min, max, headerText, subtext, inputPattern, valid } = this.props;
    const { open } = this.state;
    const descriptionText =
      max <= value ? `Max value ${max} or lower` : subtext || `Min value ${min} or greater`;
    return (
      <div
        className={cx(
          'dropdown dropdown-unified dropdown-unified-button-header hide-header-text dropdown-selected z-index-3 dropdown-number-input',
          open ? 'open' : ''
        )}
      >
        <button
          type="button"
          onClick={(e) => this.handleClick(e)}
          className="btn btn-dropdown btn-sm dropdown-unified-arrow no-caret hms-btn--light"
        >
          <span className="text-truncate">&nbsp;</span>
        </button>
        <div className="dropdown-menu">
          <p className="text-16 text-black">{headerText}</p>
          <InputText
            name="someName"
            id="someId"
            size="sm"
            required="required"
            pattern={inputPattern}
            placeholder={min.toString()}
            value={value}
            isInvalid={!valid}
            onChange={onChange}
          />
          <p className={cx('text-quiet d-flex', !valid ? 'text-red' : '')}>
            {!valid && <i className="hicon-warning text-16 mr-xxxs" />}
            <span style={{ fontSize: 14, whiteSpace: 'pre-wrap' }}>{descriptionText}</span>
          </p>
        </div>
      </div>
    );
  }
}

export default onClickOutside(InputDropdown);
